import classNames from 'classnames';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as Arrow } from 'src/assets/arrow-down.svg';
import { ReactComponent as CloseCross } from 'src/assets/close_cross_v2.svg';
import { ReactComponent as LogoOriginIcon } from 'src/assets/cvs_logo_orig.svg';
import { ReactComponent as Hamburger } from 'src/assets/hamburger.svg';
import { ReactComponent as SearchIcon } from 'src/assets/search_icon.svg';
import AccessibilitySettings from 'src/components/common/header/accessibility/accessibility-settings';
import { ReactComponent as SwitchToDisabledMode } from 'src/assets/accessibility-switch-to-standard.svg';
import * as r from 'src/constants/routes';
import Feedback from 'src/pages/feedback/feedback';
import MenuPopup from '../modals/menu-popup';
import SearchPopup from '../modals/search-popup';
import css from './navbar.module.scss';
import { useResize } from 'src/hooks/shared-hooks';
import MoreMenuPopup from '../modals/more-menu-popup';
import { useGetMenuPage } from 'src/pages/custom-page/data/queries';

export default function Navbar() {
  const route = useLocation();
  const { data: pages = [] } = useGetMenuPage();
  const [openMenu, setOpenMenu] = useState(false);
  const [openMoreMenu, setOpenMoreMenu] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [showAccessibilityMode, setShowAccessibilityMode] = useState(false);

  const dimensions = useResize();
  const mobileMode = dimensions.width < 500;

  const switchMenu = () => setOpenMenu(!openMenu);

  const swithchMoreMenu = () => setOpenMoreMenu(!openMoreMenu);

  const switchSearch = () => setOpenSearch(!openSearch);

  const switchAccessibilityMode = () => setShowAccessibilityMode(!showAccessibilityMode);

  return (
    <nav
      className={classNames(css.navbar, {
        [css.open]: openMenu || openSearch || showAccessibilityMode || openMoreMenu
      })}>
      <div className={css.container}>
        <div className={css.logo}>
          <Link to={r.GENERAL.path} className={css.logoWrapper}>
            <LogoOriginIcon />
            На зв'язку
          </Link>
        </div>
        <ul className={mobileMenu ? '' : css.hidden}>
          <div className={css.header} onClick={() => setMobileMenu(!mobileMenu)}>
            <CloseCross onClick={() => setMobileMenu(!mobileMenu)} />
          </div>
          <li className={css.menu}>
            <MenuPopup
              onOpen={switchMenu}
              onClose={() => {
                setMobileMenu(false);
                switchMenu();
              }}
              trigger={
                <button className={classNames(css.switch, { [css.top]: openMenu })}>
                  Розділи <Arrow />
                </button>
              }
            />
          </li>
          <li className={css.menu} onClick={() => setMobileMenu(false)} /*NOSONAR*/>
            <Link to={r.ABOUT.path}>Що таке на зв'язку?</Link>
          </li>
          <li className={css.menu} onClick={() => setMobileMenu(false)} /*NOSONAR*/>
            <Link to={r.PARTNERSHIP.path}>Партнери</Link>
          </li>
          {pages.length > 0 && (
            <li className={css.menu} onClick={() => setMobileMenu(false)} /*NOSONAR*/>
              <MoreMenuPopup
                dropdownItems={pages}
                onOpen={swithchMoreMenu}
                onClose={() => {
                  setMobileMenu(false);
                  swithchMoreMenu();
                }}
                trigger={
                  <button className={classNames(css.switch, { [css.top]: openMoreMenu })}>
                    Більше <Arrow />
                  </button>
                }
              />
            </li>
          )}
          <li className={classNames(css.actionBtns, { [css.float]: !mobileMode })}>
            <Feedback trigger={<button className={css.switch}>Залишити відгук</button>} />
          </li>
          <li className={css.actionBtns}>
            <AccessibilitySettings
              onOpen={switchAccessibilityMode}
              onClose={switchAccessibilityMode}
              trigger={
                <button className={css.switch} onClick={switchAccessibilityMode}>
                  <div className={css.svgContainer}>
                    <SwitchToDisabledMode />
                  </div>
                  Доступність
                </button>
              }
            />
          </li>
          <li className={css.actionBtns}>
            {!route.pathname.startsWith(r.GLOBAL_SEARCH.path) && !mobileMode && (
              <SearchPopup
                onOpen={switchSearch}
                onClose={switchSearch}
                trigger={
                  <button className={classNames(css.switch, css.search)} onClick={switchSearch}>
                    <SearchIcon className={css.searchIcon} />
                    Пошук
                  </button>
                }
              />
            )}
          </li>
        </ul>
        <div className={css.mobileMenu} onClick={() => setMobileMenu(!mobileMenu)}>
          <Hamburger />
        </div>
      </div>
    </nav>
  );
}
